import { UserMenu } from "../components/user-menu";

type Subscriber = {
  uid: string,
  email: string,
}

const configureUserMenu = ( user: Subscriber ) => {
  const userMenuElems = document.querySelectorAll( 'im-user-menu' ) as NodeListOf<UserMenu>;

  userMenuElems.forEach( element => {
    element.classList.remove( 'hidden' );

    element.initials = user.email.slice( 0, 2 ).toUpperCase();

    // TODO: set categories
  } );
}

// Fetch logged in user data
const doRest = async () => {
  try {
    const url = new URL( window.infonews.rest_base_url + 'infonews/v1/getUser' );
    const promise = await fetch( url );
    const userData = await promise.json();
    
    // set info in localstorage
    localStorage.setItem( 'infonews_subscriber', JSON.stringify( userData ) );

    // set info in user menus
    configureUserMenu( userData );
  }
  catch ( error ) {
    localStorage.removeItem( 'infonews_subscriber' );
  }
}

export default function() {
  doRest();
}
